import { FC } from 'react';
import MuiDivider from '@mui/material/Divider';
import { twMerge } from 'tailwind-merge';
import classnames from 'classnames';

interface DividerProps {
  variant?: 'fullWidth' | 'inset' | 'middle';
  className?: string;
  orientation?: 'horizontal' | 'vertical';
}

const Divider: FC<DividerProps> = ({ variant = 'fullWidth', className = '', orientation = 'horizontal' }) => {
  return <MuiDivider variant={variant} className={`${twMerge(classnames(className))}`} orientation={orientation} />;
};

export default Divider;
